export const setDataSearchOutstandingInvoice = (payload) => {
  return {
    type: "SET_DATA_SEARCH_OUTSTANDING_INVOICE",
    payload,
  };
};

export const resetOutstandingInvoice = (payload) => {
  return {
    type: "RESET_OUTSTANDING_INVOICE",
    payload,
  };
};